import { useDispatch } from 'react-redux';
import FJPhotoRemoveBgLeftContainer from './FJPhotoRemoveBgLeft/container/FJPhotoRemoveBgLeftContainer';
import FJPhotoRemoveBgRightContainer from './FJPhotoRemoveBgRight/container/FJPhotoRemoveBgRightContainer';
import { useEffect } from 'react';
import FJActionPhotoBgRemover from '../../redux/action/FJActionPhotoBgRemover';

const FJPhotoRemoveBg = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(FJActionPhotoBgRemover.initPhotoRemoveBgProjectAction());
    }, [dispatch]);
    return (
        <>
            <FJPhotoRemoveBgLeftContainer />
            <FJPhotoRemoveBgRightContainer />
        </>
    );
};

export default FJPhotoRemoveBg;
